import { Suspense, lazy } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { PublicApp } from '@/public/PublicApp'

/**
 * 관리자 묶음은 **지연 로드한다.** 같은 묶음에 두면 두 영역의 CSS 가 한 파일로 합쳐져
 * 공개 화면의 유틸리티가 관리자 화면에도 듣게 된다(사용자 결정 2026-09-07).
 */
const AdminApp = lazy(() => import('@/admin/AdminApp').then((m) => ({ default: m.AdminApp })))

/**
 * 주소로 영역을 가른다 — `/admin` 아래는 관리자, 그 밖은 공개 화면.
 *
 * **라우터를 만들기 전에 가른다.** 관리자는 데이터 라우터(`createBrowserRouter`)를 쓰고 공개는
 * `<BrowserRouter>` 를 쓰는데, react-router 는 라우터 안에 라우터를 두는 것을 금지한다
 * («You cannot render a <Router> inside another <Router>» — 실측). 그래서 판단에
 * `useLocation` 을 쓰지 못하고 `window.location` 을 읽는다.
 *
 * 이 갈림은 **첫 로드 때 한 번만** 일어난다. 공개↔관리자 이동은 문서를 새로 여는 링크
 * (`<a href>`)여야 한다 — 라우터 내부 이동으로는 서로의 라우트에 닿지 않는다.
 */
export function App() {
  const { pathname } = window.location
  const isAdmin = pathname === '/admin' || pathname.startsWith('/admin/')

  if (isAdmin) {
    return (
      <Suspense fallback={null}>
        <AdminApp />
      </Suspense>
    )
  }

  return (
    <BrowserRouter>
      <PublicApp />
    </BrowserRouter>
  )
}
